"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _reactHotkeys = require("react-hotkeys");

const Share = props => {
  // hotKeys
  const keyMap = {
    SHARE: ['s', 'S']
  };
  const handlers = {
    SHARE: () => {
      props.callbacks.onShare();
    }
  };
  const {
    isCollapsed,
    hasToolTip
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHotkeys.GlobalHotKeys, {
    keyMap: keyMap,
    handlers: handlers
  }), hasToolTip && /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
    id: "share-tooltip",
    effect: "solid",
    place: isCollapsed ? 'left' : 'top',
    className: "share__tooltip"
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "share",
    onClick: props.callbacks.onShare,
    "data-tip": props.texts.share,
    "data-for": "share-tooltip"
  }));
};
/* eslint-disable react/no-unused-prop-types */


Share.propTypes = {
  callbacks: _propTypes.default.shape({
    onShare: _propTypes.default.func
  }),
  texts: _propTypes.default.shape({
    share: _propTypes.default.string
  }),
  isCollapsed: _propTypes.default.bool,
  hasToolTip: _propTypes.default.bool
};
/* eslint-enable react/forbid-prop-types */

Share.defaultProps = {
  callbacks: {},
  texts: {
    share: 'Share (s)'
  },
  isCollapsed: false,
  hasToolTip: false
};
var _default = Share;
exports.default = _default;